module.exports = __webpack_public_path__ + "static/media/baiduxiao.53706645.png";